import React,{useState, useEffect} from 'react';
import assetify from "@quintype/framework/assetify";
import podcastIcon from ".././../../assets/images/listening.svg";
import { connect, useSelector } from "react-redux";
import { getGlobalPlayerRef } from "../podcast-player/utils";
import { Loader } from "../podcast-player/utils";
import { IS_OPEN_LOGIN_FORM } from "../helper/actions";
import get from "lodash/get";
import PropTypes from "prop-types";
import "./floating-pod-button.m.css"

function FloatingPodButton(props){

    const [showFab, setShowFab] = useState(true)

    const [data, setData] = useState({
        showPlayer: false,
        loadingUserQueue: false,
        playerState: {},
    })

    useEffect(()=> {
        const playerRef = getGlobalPlayerRef();
        const removePlayerListener = playerRef.addPlayerListener(state => {
            setData({
              showPlayer: (state.showPlayer && state.currentTrackId) || !!state.currentScreen,
              loadingUserQueue: state.loadingUserQueue,
              playerState: state
            });
        });
        !data.showPlayer?removePlayerListener():null;
    },[data.showPlayer])

    const handleClick = () => {
      const playerRef = getGlobalPlayerRef();
  
      if (data.playerState.currentTrackId) {
        playerRef.togglePlayer();
      } else {
        playerRef.setCurrentScreen("library");
      }     
    }
    

    if(data.showPlayer===false)
    return(
        <button styleName="fab"  onClick={() => handleClick()}>
          <img width="70%" src="https://img.icons8.com/pastel-glyph/64/ffffff/radio.png"/>
        </button>
    )
    else{return null;}
}

FloatingPodButton.propTypes = {
    socialLinks: PropTypes.object,
    menu: PropTypes.array,
    member: PropTypes.object,
    manageLoginForm: PropTypes.func,
    userSubscription: PropTypes.object,
    memberLoading: PropTypes.bool
  };
  
  const mapDispatchToProps = dispatch => ({
    manageLoginForm: function(payload) {
      dispatch({
        type: IS_OPEN_LOGIN_FORM,
        payload: payload
      });
    }
  });
  
  function mapStateToProps(state) {
    const domainslug = get(state, ["qt", "domainSlug"], "");

    return {
      title: "Newslaundry",
      userSubscription: get(state, ["hasSubscripton"], {}),
      member: get(state, ["member"], null),
      memberLoading: state.memberLoading,
      currentPath: get(state, ["qt", "currentPath"], ""),
      currentHostUrl: get(state, ["qt", "currentHostUrl"], ""),
      authHost: get(state, ["qt", "config", "publisher", "publisher", "auth_host"], null),
      domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
    };
  }
  
export default connect(mapStateToProps, mapDispatchToProps)(FloatingPodButton);
